export default __webpack_public_path__ + "static/media/plug.0ce56375.png";